import { Badge, Button, Card, Spinner } from "../../../shared";
import { CardHeader } from "../../../shared/Card/CardHeader";
import {
  formatBillingCycleLabel,
  formatBillingDate,
  formatMoneyFromCents,
  getCustomerFacingBillingStatus,
  isManualBillingCollection,
} from "./billing.utils";

/**
 * Primary subscription summary card for Settings > Billing.
 */
export const BillingCurrentPlan = ({
  loading = false,
  planName = "—",
  planCost = null,
  billingCycle = "Monthly",
  nextBillingDate = null,
  billingAccount = {},
  collectionMethod = "manual_invoice",
  requiresBillingAttention = false,
  canManagePortal = false,
  canStartCheckout = false,
  checkoutLoading = false,
  portalLoading = false,
  onStartCheckout,
  onManageBilling,
}) => {
  const status = getCustomerFacingBillingStatus({
    billingAccount,
    collectionMethod,
    requiresBillingAttention,
  });

  return (
    <Card
      header={
        <CardHeader
          title="Your subscription"
          actions={
            <div className="flex flex-wrap gap-2">
              {canStartCheckout && !isManualBillingCollection(collectionMethod) ? (
                <Button
                  title={checkoutLoading ? "Opening..." : "Choose a plan"}
                  size="sm"
                  onClick={onStartCheckout}
                  disabled={checkoutLoading}
                />
              ) : null}
              {canManagePortal ? (
                <Button
                  title={portalLoading ? "Opening..." : "Manage billing"}
                  size="sm"
                  type="light"
                  onClick={onManageBilling}
                  disabled={portalLoading}
                />
              ) : null}
            </div>
          }
        />
      }
      content={
        loading ? (
          <Spinner />
        ) : (
          <div className="space-y-4">
            <div className="flex flex-wrap items-center gap-3">
              <Badge color={status.badgeColor} size="lg">
                {status.label}
              </Badge>
              <p className="text-sm text-gray-600">{status.description}</p>
            </div>

            <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              <div>
                <dt className="text-sm text-gray-500">Plan</dt>
                <dd className="text-lg font-semibold text-gray-900">{planName}</dd>
              </div>
              <div>
                <dt className="text-sm text-gray-500">Price</dt>
                <dd className="text-lg font-semibold text-gray-900">
                  {planCost != null ? formatMoneyFromCents(planCost) : "Per contract"}
                </dd>
              </div>
              <div>
                <dt className="text-sm text-gray-500">Billing cycle</dt>
                <dd className="text-lg font-semibold text-gray-900">
                  {formatBillingCycleLabel(billingCycle)}
                </dd>
              </div>
              <div>
                <dt className="text-sm text-gray-500">Next billing date</dt>
                <dd className="text-lg font-semibold text-gray-900">
                  {nextBillingDate ? formatBillingDate(nextBillingDate) : "—"}
                </dd>
              </div>
            </dl>
          </div>
        )
      }
    />
  );
};
